import React from 'react';

const ButtonTransparent = (props) => {
  return (
    <button className={'btn btn--transparent ' + props.className} onClick={props.onClick ? props.onClick : null}>
      <span>{props.name}</span>
    </button>
  );
}

export default ButtonTransparent;
